// src/pages/Users/PassageCeintureDocuments/components/PassageCeintureDocumentsHero.jsx

import React from "react";
import {
  FaCheckCircle,
  FaFileAlt,
  FaGraduationCap,
  FaPenFancy,
} from "react-icons/fa";

export default function PassageCeintureDocumentsHero({
  totalCount,
  filteredCount,
  publishedCount,
  draftCount,
  canManage,
}) {
  return (
    <section className="relative overflow-hidden rounded-[2rem] bg-slate-950 p-5 text-white shadow-xl shadow-slate-950/10 sm:p-6">
      <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-violet-500/30 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-20 -left-20 h-44 w-44 rounded-full bg-sky-500/30 blur-3xl" />

      <div className="relative">
        <p className="text-xs font-bold uppercase tracking-[0.28em] text-sky-200">
          Ressources pédagogiques
        </p>

        <div className="mt-3 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="text-2xl font-bold tracking-tight sm:text-3xl">
              Documents de progression
            </h2>

            <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-200">
              Fiches, visuels et PDF pour accompagner les adhérents dans leur
              préparation aux passages de ceinture.
            </p>
          </div>

          <div className="grid grid-cols-3 gap-2 sm:min-w-[360px]">
            <HeroStat icon={FaFileAlt} label="Total" value={totalCount} />
            <HeroStat icon={FaGraduationCap} label="Affichés" value={filteredCount} />
            <HeroStat
              icon={canManage ? FaPenFancy : FaCheckCircle}
              label={canManage ? "Brouillons" : "Publiés"}
              value={canManage ? draftCount : publishedCount}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function HeroStat({ icon: Icon, label, value }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/10 p-3 text-center backdrop-blur">
      <div className="mx-auto flex h-9 w-9 items-center justify-center rounded-xl bg-white/15">
        <Icon className="text-sm text-white" />
      </div>

      <p className="mt-2 text-lg font-bold leading-none">{value}</p>
      <p className="mt-1 text-[11px] font-medium text-slate-300">{label}</p>
    </div>
  );
}